<template lang="pug">
	.job-materials
		add-item(
			:options='materialsOptions'

			@submitted='addMaterial'
		)
		.materials(v-if='materials.length')
			.material(v-for='material in materials')
				p.description {{ material.description }}
				p Added by {{ material.creator.name }} {{ formatDate( material.createdAt ) }}
		p.spacey(v-else) No Materials To Show
</template>

<script>
import AddItem from '@/components/form-inputs/AddItem';

import { AddMaterials, GetMaterials } from '@/lib/API';
import { FormatDate } from '@/lib/utils';

export default {
	name : 'job-materials',

	props : {
		asset : {
			type     : Object,
			required : true,
		}
	},

	data : () => ( {
		materials : [],

		materialsOptions : {
			title       : 'Add Material',
			label       : 'Description',
			placeholder : 'e.g. 32\' of 18" piping',
		},
	} ),

	watch : {

		asset : {
			immediate : true,
			handler( asset ) {
				if ( asset ) {

					GetMaterials( asset.jobsKey )
						.then( ( val ) => {
							this.materials = val;
						} );

				}
			}
		},

	},

	methods : {

		addMaterial( val ) {

			const displayState = this.$store.dispatch( 'displayState', {
				message : 'Adding Material...',
				state   : 'loading'
			} );

			displayState
				.then( stateIndicator => AddMaterials( val, this.asset.jobsKey )
					.then( () => stateIndicator )
					.catch( () => stateIndicator.fail( { header : 'Didn\'t Add Material', message : '' } ) ) )
				.then( ( stateIndicator ) => {
					this.$store.dispatch( 'removeDisplayState', stateIndicator.index );
				} )
				.then( () => GetMaterials( this.asset.jobsKey ) )
				.then( ( materials ) => {
					this.materials = materials;
				} );
		},

		formatDate( date ) {
			return FormatDate( date, 'MM/DD/YYYY' );
		}

	},

	components : {
		AddItem,
	}
};
</script>

<style lang="scss">
.job-materials {
	// External Styling of DropBox
	.add-item {
		margin: 25px 110px;
		position: relative;
		z-index: 0;
		margin-bottom: 20px;

		h1 {
			text-align: center;
		}
	}

	.materials {
		box-shadow: $box-shadow-primary;
		margin: 25px 110px;
		border-radius: 10px;
		padding: 12px 0px;

		.material {
			padding: 5px 17px;
			display: flex;
			justify-content: space-between;

			p {
				font-size: 14px;
			}

			p.description {
				color : $color-primary;
			}

		}
	}

	.spacey {
		text-align: center;
	}
}

@media only screen and ( max-width: 640px ) {

	.job-materials {

		.add-item {
			display: none;

			+ p.spacey {
				margin-top: 30px;
			}
		}
	}
}
</style>
